module.exports = __webpack_public_path__ + "static/img/logo.a1e8b0fe.png";